/* eslint-disable import/no-webpack-loader-syntax */
import { getAIPageContextInstance } from '@/utils/global/api';
import logger from '@/utils/logger';
import dts from '!!raw-loader!./wuji-upload.d.ts';
export async function getTypeDefinitions() {
    logger.log(dts);
    return dts;
}
export default class WujiUpload {
    uploadImage = (file, filePath, cosId) => {
        const w = getAIPageContextInstance();
        return w.uploadImage(file, filePath, cosId);
    };
    uploadFile = (file, filePath, cosId) => {
        const w = getAIPageContextInstance();
        return w.uploadFile(file, filePath, cosId);
    };
    /**
     * 前端跨域直传文件到 COS（绕过无极 server，避免 413 大文件限制）
     * 优先使用此方法上传文件
     */
    uploadFileCors = (file, filePath, cosId) => {
        const w = getAIPageContextInstance();
        return w.uploadFileCors(file, filePath, cosId);
    };
    // 支持 import upload from '@wujibase/wuji-upload' 的形式
    get default() {
        return this;
    }
}
